<script>
import { mapGetters, mapState } from 'vuex'
import { breakpointsMixin } from '../../mixins/breakpointsMixin'
import Translate from '@components/translate'

export default {
  components: {
    Translate
  },
  data () {
    return {
      nextIndex: 0,
      prevIndex: null,
      beforePrev: null,
      key: 0,
      options: [
        {
          routeName: 'Info'
        },
        {
          routeName: 'Subscription'
        },
        {
          routeName: 'Password'
        },
        {
          routeName: 'Purchases'
        },
        {
          selector: true
        }
      ]
    }
  },
  mixins: [breakpointsMixin],
  mounted () {
    this.nextIndex = this.options.findIndex((route) => route.routeName === this.$route.name)
    this.alignSelectedRect()
  },
  computed: {
    ...mapState(['user', 'home', 'settings', 'challenges', 'challengePage']),
    ...mapGetters(['primaryColor', 'primaryColorRgb', 'loggedIn']),
    userAvatar () {
      return this.user &&
        this.user &&
        this.user.profile &&
        this.user.profile.image &&
        this.user.profile.image !== ''
        ? this.user.profile.image
        : require('@assets/placeholder-avatar.png')
    },
    userName () {
      return this.user &&
      this.user.profile &&
      this.user.profile.name
    }
  },
  methods: {
    async signOut () {
      await this.$store.commit('setUser', null)
      await this.$store.commit('setCouponData', {})
      await this.$store.commit('setSelectedOrder', {})
      await localStorage.removeItem('pcc-user')
      // eslint-disable-line
      // await FB.getLoginStatus(function(response) { // eslint-disable-line
      //   // eslint-disable-line
      //   if (response && response.status === 'connected') {
      //     FB.logout(function(response) { // eslint-disable-line
      //       // eslint-disable-line
      //       document.location.reload()
      //     })
      //   }
      // })
      window.Leanplum.stop()
      this.$router.push('/').catch((err) => {}) // eslint-disable-line
    },
    alignSelectedRect () {
      const rect = document.getElementsByClassName('selector')[0]
      const item = document.getElementsByClassName('profile-item')[this.nextIndex]
      if (rect && rect.parentNode && item) {
        const parentNode = rect.parentNode.getBoundingClientRect()
        const distanceFromParent = item.getBoundingClientRect().top - parentNode.top
        if (distanceFromParent > 0) {
          rect.style.top = distanceFromParent + 1 + 'px'
        }
      }
    },
    title (route) {
      switch (route) {
        case 'Info':
          return 'profile.nav.profile'
        case 'Subscription':
          return 'profile.nav.subscription'
        case 'Password':
          return 'profile.nav.changepassword'
        case 'Purchases':
          return 'profile.nav.purchases'
        default:
          return ''
      }
    },
    handleClick (i, route) {
      if (this.$route.name !== route) {
        this.nextIndex = i
        this.alignSelectedRect()
        this.$router.push({ name: route })
        this.$emit('hide-router-view')
      }
    }
  },
  watch: {
    nextIndex (n, o) {
      this.prevIndex = o
    }
  }
}
</script>

<template>
  <div class="sidebar-container"  :style="{ '--BGColor': `rgba(${primaryColorRgb}, ${1})`}">
    <div class="row">
      <div class="col user-avatar">
        <img :src="userAvatar" />
        <span>{{userName}}</span>
      </div>
    </div>
    <template v-for="(option, i) in options">
      <div v-if="option && option.routeName" :class="['row profile-item']" :key="i">
        <div
          :class="['col option', { selected: i === nextIndex && !isMobile }]"
          @click="handleClick(i, option.routeName)"
        >
          <Translate :directive="title(option.routeName)" />
        </div>
      </div>
      <div v-if="option && option.selector" class="selector" :style="{ display: isMobile ? 'none' : 'flex'}" :key="i">
        <BaseIcon :class="['icon-arrow']" name="chevron-right"/>
      </div>
    </template>
    <div class="row">
      <div class="col option logout" @click="signOut">
        <Translate directive="logout" />
      </div>
    </div>
    <div class="row contact">
      <div class="col option">
         <span><Translate directive="profile.help" /><strong><a href="mailto:support@plankk.com" target="_blank"><Translate directive="profile.chat" /></a></strong></span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.sidebar-container {
  height: 100%;
  border-right: 2px rgba(136, 136, 136, 0.4) solid;
  padding-top: 3rem;
  padding-right: 2rem;
  .row {
    width: 100%;
  }
  .user-avatar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-right: unset;
    padding-left: unset;
    margin-bottom: 2rem;
    img {
      width: 2.3rem;
      height: 2.3rem;
      border-radius: 50%;
    }
    span {
      margin-left: 1rem;
      font-family: $base-font-family;
      font-style: normal;
      font-weight: bold;
      font-size: 18px;
      line-height: 25px;
      text-transform: capitalize;
    }
  }
  .selector {
      top: 15.5%;
      height: 3.3rem;
      background-color: var(--BGColor);
      position: absolute;
      transition: all 0.5s ease;
      color: white;
      right: 0%;
      left: 4%;
      z-index: -1;
      border-radius: 8px;
      width: 83%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      svg {
         margin-right: 1.5rem;
         color: white;
      }
    }
  .option {
    position: relative;
    white-space: nowrap;
    cursor: pointer;
    border-radius: 8px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-style: normal;
    font-weight: normal;
    overflow: hidden;
    transition: 0.5s all linear;

    span {
      margin-left: 1rem;
      position: relative;
    }
    &.logout {
      background: white;
      color: var(--BGColor);
      margin-top: 1rem;
      padding-top: unset;
      padding-bottom: unset;
    }
    &.selected {
      color: white;
    }
  }
  .contact {
    margin-top: 8rem;
    margin-bottom: 2rem;
    .option {
      cursor: pointer;
      border-radius: 8px;
      padding-top: 1rem;
      padding-bottom: 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.3rem;
      font-style: normal;
      font-weight: normal;
      background: rgba(158, 158, 158, 0.12);
      transition: all $duration-animation-base;
      &:hover {
        background: rgba(158, 158, 158, 0.32);
      }
      a {
        color: #212529;
        margin-left: 1rem;
        text-decoration: none !important;
        font-size: 1rem;
      }
    }
  }
}
</style>
